import { FormEvent, useRef, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loading from "../../../assets/images/loading.gif"
import { makeGetRequest, makePostRequest } from "../../../request";
import { useSelector } from "react-redux";
import { customStyles, formatCurrency } from "../../../helpers";
import Modal from "react-modal"
import Layout from "../../Layout";

const CreateConsolidatedDocument =  () => {
    const navigate = useNavigate()
    const user:any = useSelector((state: any) => state.tepngUser.value);  
    const [formData, setFormData] = useState<Record<string, any>>({
        countryOfSupply: "",
        countryOfOrigin: "",
        soldTo: "",
        shipTo: "",
        supplier: "",

        modeOfShipping: "SEA",        
        formM: "",
        baNumber: "",
        freightForwarderId: "",
        totalUnitPrice: 0,
        sumTotal: 0,
        purchaseOrderItemSupplies: [],
        consignee: "",
        destinationPlant: "",
        poNumber: "",
        mrdNumber: "",
    })
    const [errorData, setErrorData] = useState<Record<string, string>>()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    // const [formattedPurchaseOrderItems, setFormattedPurchaseOrderItems] = useState([])
    const [isPurchaseOrderItemsPresentForSea, setIsPurchaseOrderItemsPresentForSea] = useState<boolean>()
    const [isPurchaseOrderItemsPresentForAir, setIsPurchaseOrderItemsPresentForAir] = useState<boolean>()
    const [packagesForSea, setPackagesForSea] = useState<Record<string, any>>()
    const [packagesForAir, setPackagesForAir] = useState<Record<string, any>>()    
    const [expectedDataByCurrency, setExpectedDataByCurrency] = useState<Record<string, any>>({})
    const [selectedExpectedDataByCurrency, setSelectedExpectedDataByCurrency] = useState<Record<string, any>>({})
    const [currencyData, setCurrencyData] = useState<Record<string, any>>({
        availableCurrencies: [], // the currenciesByModeOfShipping with data
        selectedCurrency: "",
    })

    const [finalShippingAddresses, setFinalShippingAddresses] = useState<Record <string, any>[]>([])
    const getSAPFinalShippingAddressMapper = () => {
        var request: Record<string, any> = {
            what: "getSAPFinalShippingAddressMapper",
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                setFinalShippingAddresses(res)
            })
            .catch((error:any) => 
                console.log(error.errorMessage)
            );    
        }

    const groupPackageDataByCurrency = (data: any) => {
        return data?.flat().reduce((acc: any , curr: any) => {
            const currency = curr?.currency; // Get currency from the object
            if (!acc[currency]) {
                acc[currency] = []; // Initialize if not exists
            }
            acc[currency].push(curr); // Add item to the respective currency group
            return acc;
        }, {});
    };

    const getExpectedDataByCurrency = (packagesForSea: any, packagesForAir: any) => {
        const AirPackages = groupPackageDataByCurrency(packagesForAir) // usd, eur
        const SeaPackages = groupPackageDataByCurrency(packagesForSea)
        const AirItems = packagesForAir?.flatMap((pack: any) => 
            pack?.purchaseOrderItems.map((item: any) => ({
                ...item, // Spread each item's properties
                currency: pack.currency // Add currency from the parent pack
            }))
        );
        const SeaItems = packagesForSea?.map((pack:any) => pack.purchaseOrderItemSupplies)
        
        const packagesItemsGroupedByCurrency = groupPackageDataByCurrency(SeaItems?.concat(AirItems)) // {USD: [...], EUR: [...]}

        const currenciesArray = Object.keys(packagesItemsGroupedByCurrency ?? {}).sort((a: string, b:string) => a.localeCompare(b))  // ['USD', EUR] set key in an array to tab through.
        const currenciesByModeOfShipping = {
            seaMode: Object.keys(groupPackageDataByCurrency(packagesForSea) ?? {}).sort((a: string, b:string) => a.localeCompare(b)),
            airMode: Object.keys(groupPackageDataByCurrency(packagesForAir) ?? {}).sort((a: string, b:string) => a.localeCompare(b))
        }
        
        let currency: string 
        if (currencyData.selectedCurrency === "" || currencyData.selectedCurrency === undefined) {
            const newCurrency = currenciesByModeOfShipping?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]?.[0]; // Store the new currency
            currency = newCurrency
        } else {
            if(currenciesByModeOfShipping?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]?.includes(currencyData.selectedCurrency)) {   
                currency = currencyData.selectedCurrency
            } else {
                currency = currenciesByModeOfShipping?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]?.[0]
            }
        }   
        
        setCurrencyData({...currencyData, 
            selectedCurrency: currency, 
            availableCurrenciesByModeOfShipping: {
                seaMode: Object.keys(groupPackageDataByCurrency(packagesForSea) ?? {}).sort((a: string, b:string) => a.localeCompare(b)),
                airMode: Object.keys(groupPackageDataByCurrency(packagesForAir) ?? {}).sort((a: string, b:string) => a.localeCompare(b))
            },
        });  
        
        const airFilteredPackagesByCurrency = Object.entries(AirPackages ?? {})
            .filter(([key]) => key === currency)
            .flatMap(([, value]) => value as any[]);
        const airPurchaseOrderItemSupplies = airFilteredPackagesByCurrency
            .flatMap(item => item.purchaseOrderItems)
            .filter(Boolean) // Ensure we don't have undefined or null value
    
        const seaFilteredPackagesByCurrency = Object.entries(SeaPackages ?? {})
            .filter(([key]) => key === currency)
            .flatMap(([, value]) => value as any[]);
    
        const seaPurchaseOrderItemSupplies = seaFilteredPackagesByCurrency
            .flatMap(item => item.purchaseOrderItemSupplies)
            .filter(Boolean) // Ensure we don't have undefined or null values

        const selectedExpectedDataByCurrency = {
            ...(currencyData.selectedCurrency && { currency }), // USD, EUR
            ...(airFilteredPackagesByCurrency.length > 0 && {
                airMode: {
                    packageIds: airFilteredPackagesByCurrency.map(item => item.id),
                    packages: airFilteredPackagesByCurrency,
                    purchaseOrderItemSupplies: airPurchaseOrderItemSupplies,
                    totalUnitPrice: airPurchaseOrderItemSupplies.length > 0
                        ? airPurchaseOrderItemSupplies
                            .map(item => item.purchaseOrderItem?.unitPrice || 0) // Handle undefined unitPrice
                            .reduce((total, price) => total + price, 0)
                        : 0,
                    sumTotal: airPurchaseOrderItemSupplies.length > 0
                        ? airPurchaseOrderItemSupplies
                            .map(item => (item.purchaseOrderItem?.unitPrice || 0) * (item.quantity || 0)) // Handle undefined values
                            .reduce((total, value) => total + value, 0)
                        : 0,
                },
            }),
            ...(seaFilteredPackagesByCurrency.length > 0 && {
                seaMode: {
                    packageIds: seaFilteredPackagesByCurrency.map(item => item.id),
                    packages: seaFilteredPackagesByCurrency,
                    purchaseOrderItemSupplies: seaPurchaseOrderItemSupplies,
                    totalUnitPrice: seaPurchaseOrderItemSupplies.length > 0
                        ? seaPurchaseOrderItemSupplies
                            .map(item => item.purchaseOrderItem?.unitPrice || 0) // Handle undefined unitPrice
                            .reduce((total, price) => total + price, 0)
                        : 0,
                    sumTotal: seaPurchaseOrderItemSupplies.length > 0
                        ? seaPurchaseOrderItemSupplies
                            .map(item => (item.purchaseOrderItem?.unitPrice || 0) * (item.quantity || 0)) // Handle undefined values
                            .reduce((total, value) => total + value, 0)
                        : 0,
                },
            }),
        };

        // filter forAir and forSea where data.id is included in packageIdsCheckedFor...
        const forAir = airFilteredPackagesByCurrency.filter(data => packageIdsCheckedForAir?.includes(data.id))
        const forSea = seaFilteredPackagesByCurrency.filter(data => packageIdsCheckedForSea?.includes(data.id))            

        // forSea = forSea.map((data) => ({...data, isPresent: packageIdsCheckedForSea.includes(data.id)}) ).filter((data) => data.isPresent);

        let soldToValues: any[] = [];
        let shipToValues: any[] = [];
        let supplierValues: any[] = [];
        let countryOfSupplyValues: any[] = [];
        
        if(formData.modeOfShipping === "SEA") {
            // Loop through data to retrieve distinct values from each mrd.                     
            forSea.forEach((pck: any) => {
                if (!soldToValues.includes(pck.soldTo)) soldToValues.push(pck.soldTo);
                if (!shipToValues.includes(pck.shipTo)) shipToValues.push(pck.shipTo);
                if (!supplierValues.includes(pck.supplier)) supplierValues.push(pck.supplier);
                if (!countryOfSupplyValues.includes(pck.countryOfSupply)) countryOfSupplyValues.push(pck.countryOfSupply);
            });
        }else if(formData.modeOfShipping === "AIR"){
            forAir.forEach((pck: any) => {
                if (!soldToValues.includes(pck.soldTo)) soldToValues.push(pck.soldTo);
                if (!shipToValues.includes(pck.shipTo)) shipToValues.push(pck.shipTo);
                if (!supplierValues.includes(pck.supplier)) supplierValues.push(pck.supplier);
                if (!countryOfSupplyValues.includes(pck.countryOfSupply)) countryOfSupplyValues.push(pck.countryOfSupply);
            });            
        }     
        
        // Format the data to be displayed
        setFormData({...formData,
            soldTo: soldToValues.join(";"),
            shipTo: shipToValues.join(";"),
            supplier: supplierValues.join(";"),
            countryOfOrigin: formData.modeOfShipping === "SEA" ?
                Array.from(new Set(forSea.flatMap(item => item?.purchaseOrderItemSupplies?.map((item: { countryOfOrigin: string }) => item?.countryOfOrigin)))).join("; ")
                : Array.from(new Set(forAir.flatMap(item => item?.purchaseOrderItemSupplies?.map((item: { countryOfOrigin: string }) => item?.countryOfOrigin)))).join("; "),
            countryOfSupply: countryOfSupplyValues.join(", "),
        })

        // console.log(packageIdsCheckedForSea, seaFilteredPackagesByCurrency, currency)

        const expectedDataByCurrency = currenciesArray.map(currency => {
            var forAir, forSea;

            forAir = Object.entries(AirPackages ?? {})
                .filter(([key]) => key === currency)
                .flatMap(([, value]) => value as any[])
            forSea = Object.entries(SeaPackages ?? {})
                .filter(([key]) => key === currency)
                .flatMap(([, value]) => value as any[])            

            // filter forAir and forSea where data.id is included in packageIdsCheckedFor...
            forAir = forAir.filter(data => packageIdsCheckedForAir?.includes(data.id))
            forSea = forSea.filter(data => packageIdsCheckedForSea?.includes(data.id))            

            return {
                currency,
                ...(forAir.length > 0 && {
                    consignee: forAir.map(item => item?.consignee)[0],
                    destinationPlant: forAir.map(item => item?.destinationPlant)[0],
                    airMode: {
                        packageIds: forAir.map(item => item?.id),    
                        packages: forAir,    
                        purchaseOrderItemSupplies: forAir.flatMap(item => item?.purchaseOrderItems),    
                        totalUnitPrice: forAir.flatMap(item => item?.purchaseOrderItems).length > 0
                            ? forAir.flatMap(item => item.purchaseOrderItems)
                                .map(item => item?.purchaseOrderItem?.unitPrice || 0) // Handle undefined unitPrice
                                .reduce((total, price) => total + price, 0)
                            : 0,
                        sumTotal: forAir.flatMap(item => item?.purchaseOrderItems).length > 0
                            ? forAir.flatMap(item => item.purchaseOrderItems)
                                .map(item => (item?.purchaseOrderItem?.unitPrice || 0) * (item?.quantity || 0)) // Handle undefined values
                                .reduce((total, value) => total + value, 0)
                            : 0,
                    },
                }),
                ...(forSea.length > 0 && {
                    consignee: forSea.map(item => item?.consignee)[0],
                    destinationPlant: forSea.map(item => item?.destinationPlant)[0],
                    seaMode: {                        
                        packageIds: forSea.map(item => item?.id),
                        packages: forSea,
                        purchaseOrderItemSupplies: forSea.flatMap(item => item.purchaseOrderItemSupplies),
                        totalUnitPrice: forSea.flatMap(item => item.purchaseOrderItemSupplies).length > 0
                            ? forSea.flatMap(item => item.purchaseOrderItemSupplies)
                                .map(item => item?.purchaseOrderItem?.unitPrice || 0) // Handle undefined unitPrice
                                .reduce((total, price) => total + price, 0)
                            : 0,
                        sumTotal: forSea.flatMap(item => item.purchaseOrderItemSupplies).length > 0
                            ? forSea.flatMap(item => item.purchaseOrderItemSupplies)
                                .map(item => (item?.purchaseOrderItem?.unitPrice || 0) * (item?.quantity || 0)) // Handle undefined values
                                .reduce((total, value) => total + value, 0)
                            : 0,
                    },
                }),
            }
            
        });

        setSelectedExpectedDataByCurrency(selectedExpectedDataByCurrency)
        setExpectedDataByCurrency(expectedDataByCurrency)
    }

    const getPurchaseOrderItemsFromPackages = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrderItemsFromPackages",
            params: {
                FreightForwarderId: user?.id,
                consignee: formData.consignee,
                DestinationPlant: formData.destinationPlant,
                PONumber: formData.poNumber,
                MRDNumber: formData.mrdNumber
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data // returns packing list
                if(!res.length) {
                    toast.warning("No records found for consolidation!")
                    setCurrencyData({...currencyData, selectedCurrency: ""})
                }                

                // ---> GET PACKING LISTS FOR SEA AND AIR
                const PackinglistForSea = res.filter((entry: {packages: { purchaseOrderItemSupplies: { modeOfTransportation: string }[] }[]}) =>
                    entry.packages.some(pkg =>
                        pkg.purchaseOrderItemSupplies.some(supply => supply.modeOfTransportation === "SEA")
                    )
                );
                    
                // ---------------------------------------------------
                // get packing list for those pos with initial mode of transportation as AIR
                const PackinglistForAir = res.filter((packinglist: any) => 
                    packinglist.packages[0].purchaseOrderItemSupplies.some((item: any) => 
                      item.modeOfTransportation === "AIR"
                    )
                );
                
                // ---> GET PACKAGES FROM PACKING LIST
                const packages = res.map((item:any) => item.packages)                
                
                // Assuming the package dimensions is still the same after taking out the AIR items
                const packagesForSea = PackinglistForSea.flatMap((packinglist: { packages: any; mrdNumber: string, soldTo: string, shipTo: string, supplier: string, countryOfSupply: string }) => 
                                                            packinglist.packages.map((pck: any) => ({
                                                                ...pck,
                                                                mrdNumber: packinglist.mrdNumber,
                                                                soldTo: packinglist.soldTo,
                                                                shipTo: packinglist.shipTo,
                                                                supplier: packinglist.supplier,
                                                                countryOfSupply: packinglist.countryOfSupply
                                                            }))
                                                        ).filter((pck: any) => pck.purchaseOrderItemSupplies.some((item: any) => item.modeOfTransportation === "SEA"))
                                                        // identify currency and mrdNumber for each package
                                                        .map((item: any) => ({...item, 
                                                            currency: item.purchaseOrderItemSupplies[0].currency,
                                                            mrdNumber: item.mrdNumber
                                                        }))
                setPackagesForSea(packagesForSea)                

                // ---> PURCHASE ORDER ITEMS FROM PACKAGES
                const purchaseOrderItemSupplies = packages.flat().flatMap((data:any) => data.purchaseOrderItemSupplies)
                const formattedItems = purchaseOrderItemSupplies.map((item:any) => ({
                    id: item.id,
                    harmonisedSystemCode: item.harmonisedSystemCode,
                    // modeOfTranportationChangeRequestData: item.modeOfTranportationChangeRequestData, // to be included in the request
                    modeOfTransportationChangeId: item.modeOfTransportationChangeId,
                    purchaseOrderNumber: item.purchaseOrderItem.purchaseOrderNumber,
                    purchaseOrderItemNumber: item.purchaseOrderItem.purchaseOrderItemNumber,
                    purchaseOrderItemId: item.purchaseOrderItem.id,
                    materialNumber: item.purchaseOrderItem.materialNumber,
                    materialDescription: item.purchaseOrderItem.materialDescription,
                    unitPrice: item.purchaseOrderItem.unitPrice,
                    quantity: item.quantity,
                    modeOfTransportation: item.modeOfTransportation,
                    modeOfTransportationChange: item.purchaseOrderItem.modeOfTransportationChange,
                    countryOfOrigin: item.countryOfOrigin,
                    currency: item.currency
                }))

                const PurchaseOrderItemsForSea = formattedItems.filter((item:any) => item.modeOfTransportation === "SEA")
                const PurchaseOrderItemsForAir = formattedItems.filter((item:any) => item.modeOfTransportation === "AIR")
                setIsPurchaseOrderItemsPresentForSea(!!PurchaseOrderItemsForSea.length)
                setIsPurchaseOrderItemsPresentForAir(!!PurchaseOrderItemsForAir.length)
                
                // Getting the values for AIR packages to create the corresponding packages       
                const packagesForDefaultAndMOTChangeAir = PackinglistForAir.flatMap((packinglist: { packages: any; mrdNumber: string, soldTo: string, shipTo: string, supplier: string, countryOfSupply: string }) => 
                        packinglist.packages?.map((data: any) => ({
                            isChecked: false,
                            consignee: data?.consignee,    
                            destinationPlant: data?.destinationPlant,    
                            length: data?.length,    
                            width: data?.width,
                            height: data?.height,
                            grossWeight: data?.grossWeight?.toFixed(2),
                            purchaseOrderItems: data?.purchaseOrderItemSupplies,
                            purchaseOrderItemSupplies: data?.purchaseOrderItemSupplies,
                            currency: data?.purchaseOrderItemSupplies[0].currency,
                            cubicMeter: data?.cubicMeter,
                            id: data?.id, // package id
                            mrdNumber: packinglist.mrdNumber, // Add mrdNumber from the parent packing list
                            soldTo: packinglist.soldTo,
                            shipTo: packinglist.shipTo,
                            supplier: packinglist.supplier,
                            countryOfSupply: packinglist.countryOfSupply
                        }))
                    ).flat();
                // Format the data to be displayed
                // setFormData({...formData,
                //     soldTo: soldToValues.join(";"),
                //     shipTo: shipToValues.join(";"),
                //     supplier: supplierValues.join(";"),
                //     countryOfOrigin: 
                //                     formData.modeOfShipping === "SEA" 
                //                         ? Array.from(new Set(PurchaseOrderItemsForSea.map((item: any) => item.countryOfOrigin))).join(", ") 
                //                         : formData.modeOfShipping === "AIR" 
                //                         ? Array.from(new Set(PurchaseOrderItemsForAir.map((item: any) => item.countryOfOrigin))).join(", ") 
                //                         : "",
                //     countryOfSupply: countryOfSupplyValues.join(", "),
                //     ...((packagesForDefaultAndMOTChangeAir?.length === 0 && packagesForSea?.length > 0) && {modeOfShipping: "SEA"}),
                // })
                
                setPackagesForAir(packagesForDefaultAndMOTChangeAir)                    
                getExpectedDataByCurrency(packagesForSea, packagesForDefaultAndMOTChangeAir)
            })
            .catch((error:any) => 
                toast.error(error)
            );
    }

    const handleInputChange = (e: any) => {
        const {name, value} = e.target
        setFormData({...formData, [name]: value})
    }

    const [itemSuppliesIdsFromNewPackages, setItemSuppliesIdsFromNewPackages] = useState<Record<string, any>>([])
    // const [newPackagesIdForAir, setNewPackagesIdForAir] = useState([])
    const getPackages = () => {
        var request: Record<string, any> = {
            what: "getPackagesForAirConsolidation",
            id: user?.id
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                const purchaseOrderItemIdsFromNewPackages: any = []

                res.forEach((item: any) => {
                    purchaseOrderItemIdsFromNewPackages.push(item.purchaseOrderItemSupplies.map((data: any) => data.id))            
                })
                setItemSuppliesIdsFromNewPackages(purchaseOrderItemIdsFromNewPackages)
            })
            .catch((error:any) => 
                toast.error(error)
            );
    }

    const HandleCreatePackage = (event: any, packageData: any) => {
        event.target.disabled = true   
        // setIsLoading(true)
        const data = {
            purchaseOrderItems: packageData?.purchaseOrderItems
                .map((item: {purchaseOrderItemRequestId: string, harmonisedSystemCode: string, packageId: string}) => ({
                        id: item.purchaseOrderItemRequestId,
                        harmonisedSystemCode: item.harmonisedSystemCode ?? "",
                        packageId: item.packageId
                    })),
            length: packageData.length,
            width: packageData.width,
            height: packageData.height,
            packageNumber: "1",
            grossWeight: packageData.grossWeight,
            cubicMeter: packageData.cubicMeter,            
            userId: user?.id,
            consignee: packageData.consignee,
            destinationPlant: packageData.destinationPlant,
            destination: formData.destination // Is this still needed udring consolidation
        };

        var request:Record<string, any> = {
            what: "CreatePackageForAirConsolidation",
            data: data
        }
        makePostRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                event.target.disabled = false 
                toast.success(response.msg)
                getPackages()

            }).catch((error:any) => {toast.error(error.msg); setIsLoading(false)});
    }
    
    const HandleCreateConsolidatedDocument = (e: FormEvent) => {
        e.preventDefault()

        // should have been of there was air data
        if((!formData.formM || !formData.baNumber) && expectedDataByCurrency.some((data: any) => data.airMode)) setFormData({...formData, modeOfShipping: "AIR"})

        const data: any = {
            freightForwarderId: user?.id,

            countryOfSupply: formData.countryOfSupply,
            countryOfOrigin: formData.countryOfOrigin,
            soldTo: formData.soldTo,
            shipTo: formData.shipTo,
            supplier: formData.supplier,
            
            consolidationByCurrencies: expectedDataByCurrency
                // filter if there is a seamode or airmode key
                .filter((data: any) => data.seaMode || data.airMode)
                .map((data: any) => ({
                    currency: data.currency,
                    consignee: data.consignee,
                    destinationPlant: data.destinationPlant,
                    ...(data.seaMode && {                    
                        seaMode: {
                                packageIds: data.seaMode.packageIds,
                                purchaseOrderItemSupplies: data.seaMode.purchaseOrderItemSupplies.map((item: any) => item.id),
                                totalUnitPrice: data.seaMode.totalUnitPrice,
                                sumTotal: data.seaMode.sumTotal
                            }
                        }),
                    ...(data.airMode && {
                        airMode: {
                            formM: formData.formM,
                            baNumber: formData.baNumber,
                            packageIds: data.airMode.packageIds,
                            purchaseOrderItemSupplies: data.airMode.purchaseOrderItemSupplies.map((item: any) => item.id),
                            totalUnitPrice: data.airMode.totalUnitPrice,
                            sumTotal: data.airMode.sumTotal
                        }
                    })                
                })),            
        }
        
        if (Object.values(data).every(value => value)) {
            setIsSubmitting(true)
            var request:Record<string, any> = {
                what: "CreateConsolidatedDocuments",
                data: data
            };      

            makePostRequest(request)
                .then((response: any) => {  
                    toast.success(response.msg)   
                    navigate("/freightforwarder/consolidateddocuments")                                       
                })
                .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});          
        }else toast.warning("Please provide information for all required fields")
    }
    

    const prevDestinationPlant = useRef(formData.destinationPlant)
    const prevConsignee = useRef(formData.consignee)

    useEffect(() => {
        // this logic is to avoid clearing the checked packageIds when the destinationPlant or consignee changes
        if (formData.destinationPlant && formData.consignee) {
            if (prevDestinationPlant.current !== formData.destinationPlant || prevConsignee.current !== formData.consignee) {
                setPackageIdsCheckedForAir([])
                setPackageIdsCheckedForSea([])
                prevDestinationPlant.current = formData.destinationPlant
                prevConsignee.current = formData.consignee
            }
            getPurchaseOrderItemsFromPackages()
        }
    // eslint-disable-next-line
    }, [formData.modeOfShipping, formData.destinationPlant, formData.consignee, formData.poNumber, formData.mrdNumber])

    useEffect(() => {
        getExpectedDataByCurrency(packagesForSea, packagesForAir)
        //eslint-disable-next-line
    }, [currencyData.selectedCurrency, packagesForSea, packagesForAir])

    useEffect(() => {
        getPackages() //eslint-disable-next-line
    }, [formData.modeOfShipping === "AIR"])

    useEffect(() => {
    //    getAllFinalShippingAddress()   // For Intial Destination Implementation
       getSAPFinalShippingAddressMapper()     
    }, [])

    useEffect(() => {
        if(packagesForSea?.length === 0 && packagesForAir?.length > 0) setFormData({...formData, modeOfShipping: "AIR"})        
        //eslint-disable-next-line
    }, [packagesForAir])

    const [packageIdsCheckedForAir, setPackageIdsCheckedForAir]: any = useState([])
    const [packageIdsCheckedForSea, setPackageIdsCheckedForSea]: any = useState([])

    useEffect(() => {
        // clear required error from fromM and baNumber
        if(packageIdsCheckedForAir.length === 0) setErrorData({...errorData, formM: "", baNumber: ""})
            
            //eslint-disable-next-line
    }, [packageIdsCheckedForAir])

    const handleClearSearch = (event: any, key: string) => {
        const value = event.target.value
        if(key === "mrdNumber" && !value) setFormData({...formData, mrdNumber: ""})
        if(key === "poNumber" && !value) setFormData({...formData, poNumber: ""})
    }

    const page = "Consolidated Documents"

    return (
        <Layout title={page}>
            <div className="container" >
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    
                    <div className="main-inner">                  
                        <div className="detail-top-section">
                            <div onClick={() => navigate("/freightforwarder/consolidateddocuments")} style={{width:"fit-content"}}>
                                <p><span className="material-symbols-rounded">arrow_back</span> Back to Consolidated Documents</p>
                            </div>
                              
                            <div className="tab">
                                <div className="tab-item active">
                                    <span className="material-symbols-rounded">receipt_long</span>
                                    <p>Create Consolidated Documents</p>
                                </div>
                            </div>                      
                        </div>                         
                    </div>
                    <div className="main-inner mt-1" style={{minHeight: "100vh"}}>   
                        <div className="form-view-container custom" style={{padding: "0px 4px"}}>
                            <div className="layout" style={{paddingTop: "16px"}}>
                                <div className="label">Select</div>
                                <div className="body d-grid-4 custom">  
                                    <div className='form-item span-col-1'>
                                        <label><span className="errorX mr-2">*</span> Consignee </label>
                                        <select name="consignee" value={formData.consignee} onChange={handleInputChange} required>
                                            <option value="" key="0" disabled>Select Consignee</option>
                                            <option value="TEPNG" key="1">TEPNG</option>
                                            <option value="TUPNI" key="2">TUPNI</option>
                                        </select>
                                        <p className="error">{ errorData?.consignee }</p>
                                    </div>
                                    
                                    <div className='form-item span-col-1'>
                                        <label><span className="errorX mr-2">*</span> Destination Plant </label>
                                        <select disabled={!formData.consignee} name="destinationPlant" value={formData.destinationPlant} onChange={handleInputChange} required>
                                            <option value="" key="0" disabled>Select Destination Plant</option>
                                            {
                                                Array.from(new Set(finalShippingAddresses?.map((item: any) => item.destinationPlantOrSiteOrProject)))
                                                ?.sort((a: any, b: any) => a.localeCompare(b))
                                                ?.map((item: any, index: number) => (
                                                    <option value={item} key={index}>{item}</option>
                                                ))
                                            }
                                        </select>
                                        <p className="error">{ errorData?.destinationPlant }</p>
                                    </div>

                                    <div className='form-item span-col-1'>
                                        <label><span className="errorX mr-2">*</span> Mode of Shipping</label>
                                        <select name="modeOfShipping" 
                                            value={formData.modeOfShipping} 
                                            onChange={handleInputChange} 
                                            disabled={!isPurchaseOrderItemsPresentForSea && !isPurchaseOrderItemsPresentForAir}
                                            required>
                                            <option value="SEA" disabled={!isPurchaseOrderItemsPresentForSea} title={isPurchaseOrderItemsPresentForSea ? "" : "No Data for Sea Mode of Shipping"}>SEA</option>
                                            <option value="AIR" disabled={!isPurchaseOrderItemsPresentForAir} title={isPurchaseOrderItemsPresentForAir ? "" : "No Data for Air Mode of Shipping"}>AIR</option>
                                        </select>
                                        <p className="error"></p>
                                    </div>

                                    <div className='form-item span-col-1'>
                                        <label><span className="errorX mr-2">*</span> Currency</label>
                                        <select 
                                            name="selectedCurrency" 
                                            value={currencyData?.selectedCurrency} 
                                            onChange={(e) => setCurrencyData({...currencyData, selectedCurrency: e.target.value})} 
                                            disabled={!isPurchaseOrderItemsPresentForSea && !isPurchaseOrderItemsPresentForAir}
                                            required>
                                                {
                                                    currencyData?.availableCurrenciesByModeOfShipping?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]?.map((currency: string, index: number) => {
                                                        return (
                                                            <option key={index} value={currency} disabled={Object.keys(selectedExpectedDataByCurrency).includes(currency)}>{ currency }</option>
                                                        )
                                                    })
                                                }
                                        </select>
                                        <p className="error"></p>
                                    </div>
                                </div>
                            </div>
                            <div className="layout" style={{paddingTop: "8px"}}>
                                <div className="label"></div>
                                <div className="body d-grid-2 custom">  
                                    <div className='form-item span-col-1'>
                                        <label> PO Number </label>
                                        <div className="d-flex-2">
                                            <input id="poNumberSearch" name="poNumber" onKeyUp={(event) => handleClearSearch(event, "poNumber")} />
                                            <button className="custom-button blue mt-1" style={{height: "35px"}} 
                                                            onClick={() => {
                                                                const inputValue = (document.getElementById("poNumberSearch") as HTMLInputElement)?.value;
                                                                setFormData({...formData, poNumber: inputValue});
                                                            }}>Search</button>
                                        </div>
                                    </div>
                                    
                                    <div className='form-item span-col-1'>
                                        <label> MRD Number </label>
                                        <div className="d-flex-2">
                                                <input id="mrdNumberSearch" name="mrdNumber" onKeyUp={(event) => handleClearSearch(event, "mrdNumber")}/>
                                                <button className="custom-button blue mt-1" style={{height: "35px"}}
                                                onClick={() => {
                                                                const inputValue = (document.getElementById("mrdNumberSearch") as HTMLInputElement)?.value;
                                                                setFormData({...formData, mrdNumber: inputValue});
                                                            }}>Search</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {expectedDataByCurrency.length > 0 && <form onSubmit={HandleCreateConsolidatedDocument} >                            
                            {(isPurchaseOrderItemsPresentForAir && formData.modeOfShipping !== "AIR") && 
                            <div className="alert alert-info" style={{margin: "0 12px 12px 12px", width: "auto",padding:"12px"}}>
                                <span className="material-symbols-outlined mr-2 f-16">info</span>
                                <p style={{margin: 0}}>Package(s) with AIR mode of shipment are available for consolidation. 
                                    Click <span onClick={() => setFormData({...formData, modeOfShipping: "AIR"})} style={{cursor: "pointer", color: "#175FDC", textDecoration: "underline"}}>here</span> or select "Air" from the mode of shipping field.</p>
                            </div>} 

                            {(formData.modeOfShipping === "AIR" ? packagesForAir?.length > 0 : packagesForSea?.length > 0) 
                            && <div style={{margin: "0 12px"}}>  
                                
                                <div className='table-container custom mt-2' style={{minHeight: "fit-content"}}>
                                    <table>
                                        <thead>
                                            <tr className="no-textwrap">
                                                <th></th>
                                                <th>PO Number</th>
                                                <th>MRD Number</th>
                                                <th className="text-center">Length (CM)</th>
                                                <th className="text-center">Width (CM)</th>
                                                <th className="text-center">Height (CM)</th>
                                                <th className="text-center">Cubic Meter (M<sup>3</sup>)</th>
                                                <th className="text-center">Gross Weight (KG)</th>
                                                {/* {formData.modeOfShipping === "AIR" && <th>Action</th>} */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                selectedExpectedDataByCurrency
                                                ?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]
                                                ?.packages
                                                ?.map((data:any, i:number) => {
                                                    return (
                                                        <tr key={i} >
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={(formData.modeOfShipping === "AIR" ? packageIdsCheckedForAir : packageIdsCheckedForSea).includes(data.id)}
                                                                    onChange={(event) => {
                                                                        if(formData.modeOfShipping === "SEA") {
                                                                            setPackagesForSea((prevData: { [key: string]: any }[]) => {
                                                                                return prevData.map((item: { [key: string]: any }) => {
                                                                                    //if checked is true add the id to packageidsckedforsea else remove it
                                                                                    const currentPackageId: string = data.id
                                                                                    if (event.target.checked) {
                                                                                        setPackageIdsCheckedForSea([...packageIdsCheckedForSea, currentPackageId]);
                                                                                    } else {
                                                                                        setPackageIdsCheckedForSea(packageIdsCheckedForSea.filter((id: string) => id !== currentPackageId));
                                                                                    }                                                                                

                                                                                    if (item.id === data.id) {
                                                                                        return {
                                                                                            ...item,
                                                                                            isChecked: event.target.checked
                                                                                        }
                                                                                    }
                                                                                    return item; // returns the original item if it's not the one being updated
                                                                                })
                                                                            })
                                                                        } else {
                                                                            setPackagesForAir((prevData: { [key: string]: any }[]) => {
                                                                                return prevData.map((item: { [key: string]: any }) => {
                                                                                    //if checked is true add the id to packageidsckedforair else remove it
                                                                                    const currentPackageId: string = data.id
                                                                                    if (event.target.checked) {
                                                                                        setPackageIdsCheckedForAir([...packageIdsCheckedForAir, currentPackageId]);
                                                                                    } else {
                                                                                        setPackageIdsCheckedForAir(packageIdsCheckedForAir.filter((id: string) => id !== currentPackageId));
                                                                                    }              

                                                                                    if (item.id === data.id) {
                                                                                        return {
                                                                                            ...item,
                                                                                            isChecked: event.target.checked
                                                                                        }
                                                                                    }
                                                                                    return item; // returns the original item if it's not the one being updated
                                                                                })
                                                                            })
                                                                        }
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{ data?.purchaseOrderItemSupplies?.[0]?.purchaseOrderItem?.purchaseOrderNumber}</td>
                                                            <td>{ data?.mrdNumber }</td>
                                                            <td className="text-center">{data.length}</td>
                                                            <td className="text-center">{data.width}</td>
                                                            <td className="text-center">{data.height}</td>
                                                            <td className="text-center">{data.cubicMeter}</td>                                                        
                                                            <td className="text-center">{Number(data.grossWeight)?.toFixed(2)}</td>
                                                            {false && <td>
                                                                {/* Disable button if the package hasn't already been created */}
                                                                {/* The current package items is compared against the items from the newly created packages. This is because a new package id is generated so the only means of comparism is the package items. */}
                                                                {/* {data.purchaseOrderItems?.some((item: any) => item.modeOfTransportationChangeStatus === "Approved") && <button  */}
                                                                {data.purchaseOrderItems?.some((item: any) => item?.purchaseOrderItem?.modeOfTransportationChange?.finalApprovalStatus === "Approved") && <button 

                                                                    disabled={(data.purchaseOrderItems?.map((item: any) => item.id))
                                                                        ?.every((item: any) => (itemSuppliesIdsFromNewPackages).some((subArr: any) => subArr.includes(item)))}

                                                                    type="button" 
                                                                            className="custom-button blue-outline" 
                                                                            onClick={(event) => HandleCreatePackage(event, data)}>Create Package</button>}
                                                            </td>}

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> }

                            {(formData.modeOfShipping === "AIR" ? packagesForAir?.length > 0 : packagesForSea?.length > 0) 
                            && <div style={{margin: "0 12px"}}>  
                                <p style={{ fontSize: "11px", fontWeight: "500", backgroundColor: "#175FDC", color: "white", padding: "8px", textAlign: "center", borderRadius: "4px"}}
                                className="uppercase">Selected Packages for {formData.modeOfShipping} Consolidation</p>         
                                
                                <div className='table-container custom' style={{minHeight: "fit-content"}}>
                                    <table>
                                        <thead>
                                            <tr className="no-textwrap">
                                                <th>PO Number</th>
                                                <th>MRD Number</th>
                                                <th className="text-center">Length (CM)</th>
                                                <th className="text-center">Width (CM)</th>
                                                <th className="text-center">Height (CM)</th>
                                                <th className="text-center">Cubic Meter (M<sup>3</sup>)</th>
                                                <th className="text-center">Gross Weight (KG)</th>
                                                {/* {formData.modeOfShipping === "AIR" && <th>Action</th>} */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                selectedExpectedDataByCurrency
                                                ?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]
                                                ?.packages
                                                //filter packages that are checked
                                                ?.filter((pack: any) => formData.modeOfShipping === "SEA" ? packageIdsCheckedForSea.includes(pack.id) : packageIdsCheckedForAir.includes(pack.id))  
                                                ?.map((data:any, i:number) => {
                                                    return (
                                                        <tr key={i} >
                                                            <td>{ data?.purchaseOrderItemSupplies?.[0]?.purchaseOrderItem?.purchaseOrderNumber}</td>
                                                            <td>{ data?.mrdNumber }</td>
                                                            <td className="text-center">{data.length}</td>
                                                            <td className="text-center">{data.width}</td>
                                                            <td className="text-center">{data.height}</td>
                                                            <td className="text-center">{data.cubicMeter}</td>                                                        
                                                            <td className="text-center">{Number(data.grossWeight)?.toFixed(2)}</td>
                                                            {false && <td>
                                                                {/* Disable button if the package hasn't already been created */}
                                                                {/* The current package items is compared against the items from the newly created packages. This is because a new package id is generated so the only means of comparism is the package items. */}
                                                                {/* {data.purchaseOrderItems?.some((item: any) => item.modeOfTransportationChangeStatus === "Approved") && <button  */}
                                                                {data.purchaseOrderItems?.some((item: any) => item?.purchaseOrderItem?.modeOfTransportationChange?.finalApprovalStatus === "Approved") && <button 

                                                                    disabled={(data.purchaseOrderItems?.map((item: any) => item.id))
                                                                        ?.every((item: any) => (itemSuppliesIdsFromNewPackages).some((subArr: any) => subArr.includes(item)))}

                                                                    type="button" 
                                                                            className="custom-button blue-outline" 
                                                                            onClick={(event) => HandleCreatePackage(event, data)}>Create Package</button>}
                                                            </td>}

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> }

                            {Object.keys(selectedExpectedDataByCurrency ?? {}).length !== 0 && 
                            <div style={{margin: "0 12px"}}>                 
                                <p style={{fontSize: "11px", fontWeight: "500", backgroundColor: "#175FDC", color: "white", padding: "8px", textAlign: "center", borderRadius: "4px"}}
                                className="uppercase">Materials for {formData.modeOfShipping} Consolidation</p> 
                                <div className='table-container custom' style={{minHeight: "fit-content"}}>
                                    <table>
                                        <thead>
                                            <tr className="no-textwrap">
                                                {/* <th>SN</th> */}
                                                <th>PO Number</th>
                                                <th>Material Number</th>
                                                <th>Item Number</th>
                                                <th>Material Description</th>
                                                <th>HS Code</th>
                                                <th>Quantity</th>                                            
                                                <th>Unit Price ({currencyData?.selectedCurrency})</th>
                                                <th>Total ({currencyData?.selectedCurrency})<small className="info">*Calculated</small></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                selectedExpectedDataByCurrency
                                                ?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]
                                                ?.purchaseOrderItemSupplies     
                                                //check formdata modeOfShipping to display only the items that the data.packageId is found in either packageIdsForSea or packageIdsForAir
                                                ?.filter((item: any) => formData.modeOfShipping === "SEA" ? packageIdsCheckedForSea.includes(item.packageId) : packageIdsCheckedForAir.includes(item.packageId))                                           
                                                ?.map((data: any, i: number) => {
                                                    return (
                                                        <tr key={i} >
                                                            {/* <td>{i+1}</td> */}
                                                            <td>{data.purchaseOrderItem.purchaseOrderNumber}</td>
                                                            <td>{data.purchaseOrderItem.materialNumber}</td>
                                                            <td>Item {data.purchaseOrderItem.purchaseOrderItemNumber}</td>                                                            
                                                            <td>{data.purchaseOrderItem.materialDescription}</td>
                                                            <td>{data.harmonisedSystemCode}</td>
                                                            <td>{data.quantity}</td>
                                                            <td>{formatCurrency(data.purchaseOrderItem.unitPrice)}</td>
                                                            <td>{formatCurrency(Number(data.purchaseOrderItem.unitPrice) * Number(data.quantity))}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                        <tbody>
                                            <tr style={{background: "transparent"}}>
                                                <td colSpan={5}></td>
                                                <td><strong>Total:</strong></td>
                                                <td><strong>{formatCurrency(selectedExpectedDataByCurrency
                                                    ?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]
                                                    ?.purchaseOrderItemSupplies
                                                    ?.filter((item: any) => formData.modeOfShipping === "SEA" ? packageIdsCheckedForSea.includes(item.packageId) : packageIdsCheckedForAir.includes(item.packageId))                            
                                                    ?.reduce((total: number, item: any) => total + Number(item.purchaseOrderItem.unitPrice), 0))}</strong></td>
                                                    {/* ?.totalUnitPrice)}</strong></td> */}
                                                <td><strong>{formatCurrency(selectedExpectedDataByCurrency
                                                    ?.[formData.modeOfShipping === "SEA" ? "seaMode" : "airMode"]
                                                    ?.purchaseOrderItemSupplies
                                                    ?.filter((item: any) => formData.modeOfShipping === "SEA" ? packageIdsCheckedForSea.includes(item.packageId) : packageIdsCheckedForAir.includes(item.packageId))                            
                                                    ?.reduce((total: number, item: any) => total + (Number(item.purchaseOrderItem.unitPrice) * Number(item.quantity)), 0))}</strong></td>
                                                    {/* ?.sumTotal)}</strong></td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>}

                            <div className="form-view-container custom" style={{padding: "16px 4px", borderTop: "1px solid #ccc"}} >
                                <div className="layout">
                                    <div className="label">Summary Details</div>
                                    <div className="body d-grid custom">  
                                        {formData.modeOfShipping === "AIR" && <>
                                            <div className='form-item span-col-2'>
                                                <label>Form M <small className="text-red">(Required)</small></label>
                                                <input required={packageIdsCheckedForAir.length > 0} name="formM" value={formData?.formM} onChange={handleInputChange} type='text'
                                                    onKeyUp={() => {formData.formM.length < 1 && formData.modeOfShipping === "AIR" && packageIdsCheckedForAir.length > 0
                                                        ? setErrorData({ ...errorData, formM: 'This field is required' }) : 
                                                    setErrorData({ ...errorData, formM: '' })}} />
                                                <p className="error">{ errorData?.formM }</p>
                                            </div> 

                                            <div className='form-item span-col-2'>
                                                <label>BA Number <small className="text-red">(Required)</small></label>
                                                <input required={packageIdsCheckedForAir.length > 0} name="baNumber" value={formData?.baNumber} onChange={handleInputChange} type='text'
                                                    onKeyUp={() => {formData.baNumber.length < 1 && formData.modeOfShipping === "AIR"  && packageIdsCheckedForAir.length > 0
                                                        ? setErrorData({ ...errorData, baNumber: 'This field is required' }) : 
                                                    setErrorData({ ...errorData, baNumber: '' })}} />
                                                <p className="error">{ errorData?.baNumber }</p>
                                            </div> 
                                        </>}  
                                        <div className='form-item span-col-4'>
                                            <label>Sold To</label>
                                            <textarea className="mt-1 custom-input" rows={3} disabled value={formData.soldTo}></textarea>
                                            <p className="error">{ errorData?.soldTo }</p>
                                        </div>
                                        <div className='form-item span-col-4'>
                                            <label>Ship To</label>
                                            <textarea className="mt-1 custom-input" rows={3} disabled value={formData.shipTo}></textarea>
                                            <p className="error">{ errorData?.shipTo }</p>
                                        </div>
                                        <div className='form-item span-col-4'>
                                            <label>Suppliers</label>
                                            <textarea className="mt-1 custom-input" rows={3} disabled value={formData.supplier}></textarea>
                                            <p className="error">{ errorData?.supplier }</p>
                                        </div>

                                        <div className='form-item span-col-4'>
                                            <label>Country of Origin</label>
                                            <textarea className="mt-1 custom-input" rows={3} disabled value={formData.countryOfOrigin}></textarea>
                                            <p className="error">{ errorData?.countryOfOrigin }</p>
                                        </div>   
                                        <div className='form-item span-col-4'>
                                            <label>Country of Supply</label>
                                            <input type="text" disabled value={formData.countryOfSupply} />
                                            <p className="error">{ errorData?.countryOfSupply }</p>
                                        </div>                                      
                                    </div>                                          
                                </div>
                            </div> 

                            
                            <div style={{padding: "12px", borderTop: "1px solid #ccc",}}>
                                {(formData.poNumber || formData.mrdNumber) && <p className="text-red f-14" style={{textAlign: "center", margin: "0", marginBottom: "24px"}}>*Please clear the Searched PO Number and MRD Number fields to enable the button for submission</p>}
                                <button 
                                    type="submit" 
                                    className="custom-button orange d-flex-center"
                                    style={{margin: "0 auto", width: "100%"}}
                                    disabled={(
                                            // (!formData.formM || !formData.baNumber) && packagesForAir?.length) 
                                            (!formData.formM || !formData.baNumber) && packageIdsCheckedForAir?.length) 
                                            || isSubmitting 
                                            //check the value is empty
                                            || Object.keys(selectedExpectedDataByCurrency ?? {}).length === 0
                                            //check if packages have been selected
                                            || ((packagesForSea?.length > 0 && packageIdsCheckedForSea.length === 0)
                                                && (packagesForAir?.length > 0 && packageIdsCheckedForAir.length === 0)) // for when there are packages in both sea and air
                                            || (packagesForSea?.length > 0 && packageIdsCheckedForSea.length === 0 && packagesForAir?.length === 0) // for when there are packages in only sea
                                            || (packagesForAir?.length > 0 && packageIdsCheckedForAir.length === 0 && packagesForSea?.length === 0) // for when there are packages in only air

                                            || (formData.poNumber || formData.mrdNumber) // where there is no po or mrd number
                                        }
                                    >
                                    <span className="material-symbols-rounded">web_traffic</span> {isSubmitting ? "Loading..." : "Create Consolidated Documents"}
                                </button>
                            </div>                            
                        </form>}   
                    </div>     
                </div>
                <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                    <div className="loader">
                        <img src={loading} alt="loading" />
                        <p>Loading data...</p>
                    </div>
                </Modal> 
                <ToastContainer />
            </div>            
        </Layout>
    )
}

export default CreateConsolidatedDocument